<template>

  <div class="home-dashboard grey darken-4">

    <!-- Greeting -->
    <div class="home-dashboard-greeting t-rounded grey darken-2">
      <slot name="greeting" />
    </div>

    <!-- PartOne Headers -->
    <div class="home-dashboard-headers">
      <div v-if="show_invitation_slot" class="home-dashboard-headers-invitations">
        <h2>
          Invites
        </h2>
      </div>
      <!-- <div class="home-dashboard-headers-news">
        <h2>
          News
        </h2>
      </div> -->
    </div>

    <!-- PartOne Invitaions and News -->
    <div class="home-dashboard-invitations-news">
      <div v-if="show_invitation_slot" class="home-dashboard-invitations grey darken-3">
        <slot name="invitations"/>
      </div>
      <!-- <div class="home-dashboard-news grey darken-3">
        <slot name="news"/>
      </div> -->
    </div>

    <!-- PartTwo CommunitySequences -->
    <!-- <div class="home-dashboard-community-sequences-header">
      <h2> Latest Community Sequences </h2>
    </div>
    <div class="home-dashboard-community-sequences grey darken-3">
      <slot name="CommunitySequences"/>
    </div> -->
  </div>

</template>

<script>
export default {
  props: [
    'show_invitation_slot',
  ]
}
</script>

<style>
  .home-dashboard {
    display: flex;
    flex-direction: column;
  }

    /* Greeting */
    .home-dashboard-greeting {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      margin-top: 20px;
      margin-bottom: 20px;
      margin-left: 10px;
      margin-right: 10px;
    }

    /* Headers */
    .home-dashboard-headers{
      display: flex;
      flex-direction: row;
      margin-left: 10px;
      font-family: inherit;
      font-variant: small-caps;
      height: 30px;
    }
      .home-dashboard-headers-invitations {
        width: calc(60% + 5px);
      }

    /* Invitations and News */
    .home-dashboard-invitations-news {
      display:flex;
      flex-direction: row;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      gap: 10px;
      margin-bottom: 20px;
      height: 325px;
    }
      .home-dashboard-invitations {
        display: flex;
        overflow-y: visible;
        overflow-x: scroll;
        border-style: solid;
        border-radius: 10px 10px 10px 10px;
        width: 60%;
        border-width: 3px;
        flex-shrink: 0;
      }
      .home-dashboard-news {
        display: flex;
        flex-wrap: wrap;
        overflow-y: scroll;
        border-style: solid;
        border-radius: 10px 10px 10px 10px;
        border-width: 5px;
        width: 100%;
        gap: 5px;
      }


    /* CommunitySequences */
    .home-dashboard-community-sequences-header{
      margin-left: 10px;
      height: 30px;
      font-family: inherit;
      font-variant: small-caps;
      margin-bottom: 8px;
    }
    .home-dashboard-community-sequences {
      display: flex;
      border-style: solid;
      flex-direction: column;
      justify-content: space-between;
      border-width: 3px;
      gap: 5px;
      border-radius: 10px 10px 10px 10px;
      margin-bottom: 100px;
      margin-left: 10px;
      margin-right: 10px;
      overflow-y: visible;
      border-width: 6px;
      flex-shrink: 0;
    }

</style>
